// This file now serves as a compatibility layer during migration
// It re-exports all the new stores for backward compatibility
// Eventually, components should import directly from the individual stores

import { useUserStore } from './useUserStore';
import { usePomodoroStore } from './usePomodoroStore';
import { useAudioStore } from './useAudioStore';
import { useDressStore } from './useDressStore';
import { useRestStore } from './useRestStore';

// Re-export individual stores for direct access
export { useUserStore, usePomodoroStore, useAudioStore, useDressStore, useRestStore };

// Create a combined hook for backward compatibility
export const useAppStore = () => {
  const userStore = useUserStore();
  const pomodoroStore = usePomodoroStore();
  const audioStore = useAudioStore();
  const dressStore = useDressStore();

  return {
    // User state
    user: userStore.user,
    donuts: userStore.donuts,
    affinityExp: userStore.affinityExp,
    affinityLevel: userStore.affinityLevel,
    updateUser: userStore.updateUser,
    addDonut: userStore.addDonut,
    spendDonut: userStore.spendDonut,
    addAffinityExp: userStore.addAffinityExp,

    // Pomodoro state
    pomodoroSettings: pomodoroStore.pomodoroSettings,
    currentSession: pomodoroStore.currentSession,
    pomodoroLog: pomodoroStore.pomodoroLog,
    updatePomodoroSettings: pomodoroStore.updatePomodoroSettings,
    startTimer: pomodoroStore.startTimer,
    stopTimer: pomodoroStore.stopTimer,
    resetTimer: pomodoroStore.resetTimer,
    switchPhase: pomodoroStore.switchPhase,
    completeSession: pomodoroStore.completeSession,
    updateTimerRemaining: pomodoroStore.updateTimerRemaining,
    updatePomodoroLog: pomodoroStore.updatePomodoroLog,

    // Audio state
    audioSettings: audioStore.audioSettings,
    bgmUnlocks: audioStore.bgmUnlocks,
    updateAudioSettings: audioStore.updateAudioSettings,
    unlockBgm: audioStore.unlockBgm,

    // Dress state
    selectedDress: dressStore.selectedDress,
    selectedBackground: dressStore.selectedBackground,
    dressUnlocks: dressStore.dressUnlocks,
    backgroundUnlocks: dressStore.backgroundUnlocks,
    live2dModel: dressStore.live2dModel,
    live2dScale: dressStore.live2dScale,
    live2dPositionX: dressStore.live2dPositionX,
    live2dPositionY: dressStore.live2dPositionY,
    selectDress: dressStore.selectDress,
    selectBackground: dressStore.selectBackground,
    unlockDress: dressStore.unlockDress,
    unlockBackground: dressStore.unlockBackground,
    updateLive2dSettings: dressStore.updateLive2dSettings,
  };
};